export default (data) => {
    return `<li class="popup__item">
        <a href="${data.handle}" class="popup__link -${data.platform}" target="_blank" rel="noopener noreferrer" aria-describedby="new-window">
            ${data.location}
        </a>
    </li>`;
}